import React, { Component } from "react";

import PropsType from "prop-types";
import _ from "lodash";

import { Accessor, ColorX, IconX } from "IZOX/STATIC";
import { HStack, VStack, XIconButton, XText } from "IZOX/_X";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @typedef {"success" | "warn" | "warning" | "error" | "info"} alertSeverity
 * 
 * 
 * Snack Alert for IZO Container
 * @augments {Component<Props, State>}
 */
class SnackAlert extends Component {

  static propTypes = {
    severity: PropsType.string,
    message: PropsType.any,
    onClose: PropsType.func
  };

  static defaultProps = {
    severity: "success",
    message: "",
    onClose: () => {}
  };

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(SnackAlert.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
        return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  _close = () => {
    let {onClose} = this.state;
    if(onClose) onClose();
  };

  bgColor = () => {
    let {severity} = this.state;
    switch(severity){
      default: case "success": return ColorX.CSS("Success", 0.9);
      case "warn": case "warning": return ColorX.CSS("Warn", 0.9);
      case "info": return ColorX.CSS("Info", 0.9);
      case "error": return ColorX.CSS("Error", 0.9);
    }
  };

  renderIconBySeverity(){
    let {severity} = this.state;
    let {iconSize, color} = SysConfig.Snackbar;
    switch(severity){
      default: case "none": return;
      case "success": return IconX.Get("ant", "staro", iconSize, color);
      case "warn": case "warning": return IconX.Get("ionic", "warning", iconSize, color);
      case "info": return IconX.Get("feather", "info", iconSize, color);
      case "error": return IconX.Get("mui", "error-outline", iconSize, color);
    }
  }

  renderClose(){
    let {iconSize, color} = SysConfig.Snackbar;
    return (
      <XIconButton padding={5}
        onPress={() => this._close()} 
        size={iconSize} color={color}>
          {IconX.Get("ant", "close", iconSize, color)}
        </XIconButton>
    );
      
  }

  renderInside(){
    let {message} = this.props;
    let {fontSize, color} = SysConfig.Snackbar;
    if(!_.isEmpty(message)){
      let msgs = message.toString().split("\n");
      let jsx = [];
      _.map(msgs, (o, i) => {
        jsx.push(
          <XText style={{fontSize: fontSize, color: color}} key={i}>
            {o}
          </XText>
        );
      });
      return (
        <HStack spacing={10} style={{
            paddingTop: 2,
            paddingBottom: 2,
            paddingLeft: 10,
            paddingRight: 5,
            width: "auto",
          }}>
          {this.renderIconBySeverity()}
          <VStack spacing={1}>
            {jsx}
          </VStack>
          {this.renderClose()}
        </HStack>
      );
    }
  }

  render(){
    let {message} = this.props;
    return (
      <HStack
        width={"auto"}
        style={{
          backgroundColor: this.bgColor(),
          padding: !_.isEmpty(message)? 1: 0,
          borderRadius: 25,
          boxShadow: `2px 2px 2px 1px ${ColorX.CSS("pureDark", 0.2)}`,
        }}
        >
        {this.renderInside()}
      </HStack>
    );
  }

}

export default SnackAlert;
